import {useCallback, useMemo, useState} from 'react'
import {useSelector} from 'react-redux'
import {RootState} from '../store_redux'
import utils from '../utils'

interface ErrorState {
  isError: boolean
  errorMsg: string
}

const initialState = {isError: false, errorMsg: ''}

const useError = () => {
  const [error, setError] = useState<ErrorState>(initialState)
  const {labels, modal} = useSelector((state: RootState) => state)
  const visitType = useMemo(() => {
    switch (modal.type) {
      case 'BEST_DATE':
        return modal.data.bestDate.visitType || ''
      case 'STANDARD_DATE_CHOICE':
        return modal.data.standardDateChoice.visitType || ''
      default:
        return ''
    }
  }, [modal])

  const handleError = useCallback(
    (labelKey: string, errorCode?: string) => {
      const errorMsg =
        labelKey in labels.errors
          ? utils.getErrorMsg(
              labels.errors[labelKey as keyof typeof labels.errors],
              errorCode || '500',
            )
          : 'Something went wrong. Please try again'

      setError({
        isError: true,
        errorMsg: errorMsg.includes('{visitType}')
          ? errorMsg.replace('{visitType}', visitType.toLowerCase())
          : errorMsg,
      })
    },
    // eslint-disable-next-line
    [],
  )

  return {error, setError: handleError}
}

export default useError
